import useMyPrivilegesService from "./service";
import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import ApiAccessPrivilage from "shared/types/ApiAccessPrivilage";
import PrivilegeSource from "shared/enums/PrivilegeSource";
import sortBy from "lodash/sortBy";
import Button from "shared/components/button";
import { useRegDetail } from "../../../../shared/context/regDetail";
import MyPrivilegesQrCodeWrapper from "./myPrivilegesQrCodeWrapper";
import Icon from "assets/icons";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";

export default function MyPrivileges() {
  const copies = useCopies();
  const service = useMyPrivilegesService();
  if (!service.myPrivilegesList || service.myPrivilegesList.length === 0) {
    return null;
  }
  return (
    <li ref={service.containerRef} className="myPrivilegesAction">
      <Button
        label={copies.get("my.privileges.label")}
        icon={<Icon.PremiumFeature strokeWidth={1} />}
        onClick={() => {
          service.setShowPrivilegesPanel(i => !i);
        }}
      />
      {service.showPrivilegesPanel && <MyPrivilegesListContainer privilegesList={service.myPrivilegesList || []} />}
    </li>
  );
}

function MyPrivilegesListContainer(props: { privilegesList: Array<ApiAccessPrivilage> }) {
  const copies = useCopies();
  const { badgeQRConfiguration } = useRegDetail();
  const purchasedPrivilegesList = React.useMemo(
    () =>
      sortBy(
        props.privilegesList.filter(item => item.privilegeSource?.includes(PrivilegeSource.INVENTORY)),
        "label"
      ),
    [props.privilegesList]
  );

  const complimentaryPrivilegesList = React.useMemo(
    () =>
      sortBy(
        props.privilegesList.filter(item => item.privilegeSource?.includes(PrivilegeSource.REGISTRATION_FORM)),
        "label"
      ),
    [props.privilegesList]
  );

  useLogAnalyticsScreenHook({ properties: { screenType: AnalyticsScreenNameEnum.MY_ACCESS_LIST } });

  return (
    <div className="myPrivilegesMenu">
      <div className="myPrivilegesMenu_wrapper">
        <div className="myPrivileges--container">
          {badgeQRConfiguration?.enableQR && (
            <div className="myPrivileges_qrCode">
              <div className="myPrivileges_qrCodeWrapper">
                <MyPrivilegesQrCodeWrapper />
              </div>
            </div>
          )}

          {purchasedPrivilegesList.length > 0 && (
            <div className="myPrivileges_genericPrivilegesCard">
              <h2 className="myPrivileges_genericPrivilegesCard--title">
                {copies.get("my.privileges.purchased.label")}
              </h2>
              <ul className="myPrivileges_genericPrivilegesCard--list">
                {purchasedPrivilegesList.map(item => (
                  <li className="myPrivileges_genericPrivilegesCard--listItem" key={item.id}>
                    <Icon.CheckVerified /> {item.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {complimentaryPrivilegesList.length > 0 && (
            <div className="myPrivileges_genericPrivilegesCard">
              <h2 className="myPrivileges_genericPrivilegesCard--title">
                {copies.get("my.privileges.included.label")}
              </h2>
              <ul className="myPrivileges_genericPrivilegesCard--list">
                {complimentaryPrivilegesList.map(item => (
                  <li className="myPrivileges_genericPrivilegesCard--listItem" key={item.id}>
                    <Icon.CheckVerified /> {item.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
